<template>
  <svg
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="rgba(var(--foreground))"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3935 11.3079L10.8106 10.1027C10.5852 9.99806 10.4 10.1154 10.4 10.3649V12.635C10.4 12.8846 10.5852 13.0019 10.8106 12.8972L13.3923 11.692C13.6189 11.5862 13.6189 11.4137 13.3935 11.3079ZM11.55 0.459961C5.45271 0.459961 0.51001 5.40266 0.51001 11.5C0.51001 17.5973 5.45271 22.54 11.55 22.54C17.6473 22.54 22.59 17.5973 22.59 11.5C22.59 5.40266 17.6473 0.459961 11.55 0.459961ZM11.55 15.985C5.89891 15.985 5.80001 15.4755 5.80001 11.5C5.80001 7.52441 5.89891 7.01496 11.55 7.01496C17.2011 7.01496 17.3 7.52441 17.3 11.5C17.3 15.4755 17.2011 15.985 11.55 15.985Z"
      fill="foreground"
    />
  </svg>
</template>
